import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MessageSquare, Store, Users, ShoppingBag, User, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import AuthPromptModal from './AuthPromptModal';
import GoogleAutoAuth from './GoogleAutoAuth';

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isGuest, requireAuth } = useAuth();

  const navItems = [
    { path: '/shops', icon: Store, label: 'Shops', protected: false },
    { path: '/chats', icon: MessageSquare, label: 'Chats', protected: true },
    ...(user?.isShopOwner ? [{ path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', protected: true }] : []),
    { path: '/communities', icon: Users, label: 'Groups', protected: true },
    { path: '/orders', icon: ShoppingBag, label: 'Orders', protected: true },
    { path: '/profile', icon: User, label: 'Profile', protected: true },
  ];

  const handleNavClick = (item) => {
    if (item.protected && isGuest) {
      requireAuth(`access ${item.label}`);
      return;
    }
    navigate(item.path);
  };

  const isActive = (path) => location.pathname.startsWith(path);

  // Hide bottom nav on chat windows and other detail pages
  const hideNav = location.pathname.match(/\/(chats|communities|shops|orders|dashboard)\/[^/]+/);

  return (
    <div className="app-container">
      <div className="content-area">
        <Outlet />
      </div>

      {!hideNav && (
        <nav className="bottom-nav">
          {navItems.map((item) => {
            const { path, icon: Icon, label } = item;
            return (
              <button
                key={path}
                className={`nav-item ${isActive(path) ? 'active' : ''}`}
                onClick={() => handleNavClick(item)}
                id={`nav-${label.toLowerCase()}`}
              >
                <Icon className="nav-icon" size={22} strokeWidth={isActive(path) ? 2.5 : 1.8} />
                <span>{label}</span>
              </button>
            );
          })}
        </nav>
      )}

      <AuthPromptModal />
      <GoogleAutoAuth />
    </div>
  );
}
